require("../../node_modules/select2/dist/js/select2.full.min.js");

module.exports = {
  init: () => {
    $(".select-trigger--sort").each(function() {
      $(this).select2({
        containerCssClass: "select",
        dropdownCssClass: "select-dropdown",
        minimumResultsForSearch: 30,
        width: "100%",
        placeholder: "Sorter efter"
      });
      $(this)
        .next()
        .find('b[role="presentation"]')
        .hide();
      $(this)
        .next()
        .find(".select2-selection__arrow")
        .append('<i class="far fa-long-arrow-down" />');
    });
  }
};
